<template>
	<observer @on-change="onChange" :root-margin="rootMargin" :threshold="threshold">
		<slot></slot>
	</observer>
</template>

<script>
import Jet from '@/modules/Jet'
import Observer from 'vue-intersection-observer'

export default {
	name: 'BlockVisibilityObserver',

	components: {
		Observer,
	},

	props: {
		// eslint-disable-next-line vue/require-default-prop
		title: {
			type: String,
		},

		path: {
			type: Array,
			default: () => [],
		},

		eventParams: {
			type: Object,
			default: () => ({}),
		},

		rootMargin: {
			type: String,
			default: '0px',
		},

		threshold: {
			type: [Number, Array],
			default: 0,
		},
	},

	data() {
		return {
			isAnalyticsEventSent: false,
		}
	},

	methods: {
		async onChange(entry) {
			if (entry.isIntersecting) {
				this.$emit('show', entry)

				if (!this.isAnalyticsEventSent && entry.intersectionRatio >= 1) {
					this.$analytic.logEvent('BlockView', {
						title: this.title,
						path: this.path,
						...this.eventParams,
					})

					const titleEnumExists = await Jet.titleEnumExists(this.title)
					if (titleEnumExists) {
						Jet.logUxEvent('BlockView', { title: this.title })
					}

					this.isAnalyticsEventSent = true
				}
			} else {
				this.$emit('hide', entry)
			}
		},
	},
}
</script>
